import {Pipe, PipeTransform} from '@angular/core';
import {Tool} from '../../model/tool';

@Pipe({
  name: 'tooltype',
  standalone: true,
})
export class ToolTypePipe implements PipeTransform {
  transform(value: Tool[], type: string): Tool[] {
    if (value == null) {
      return [];
    }
    return value.filter(v => {
      return v.type === type;
    });
  }
}
